/**
 * Mirrors backend HourlySalesReportService.ResolveTenderChartBucket (auto path):
 * 1 day → hour, 2–14 → day, 15+ → week.
 * @param {import('moment').Moment | Date | string} start
 * @param {import('moment').Moment | Date | string} end
 * @returns {'hour' | 'day' | 'week'}
 */
export function resolveTenderChartBucket(start, end) {
  const startMs = new Date(start).setHours(0, 0, 0, 0);
  const endMs = new Date(end).setHours(0, 0, 0, 0);
  if (Number.isNaN(startMs) || Number.isNaN(endMs)) return "day";
  const from = Math.min(startMs, endMs);
  const to = Math.max(startMs, endMs);
  const daySpan = Math.floor((to - from) / 86400000) + 1;
  if (daySpan <= 1) return "hour";
  if (daySpan <= 14) return "day";
  return "week";
}

export default resolveTenderChartBucket;
